<template>
  <div>
    <div class="wrapper">
        <!-- Sidebar  -->
        <nav id="sidebar" :class="toggleSidebar">
            <div class="sidebar-header mb-0 pb-0" v-if="userProfile != null">
              <!-- <img src="https://vesicash.com/frontend/img/vesi-logo-white.png" class="mb-4" style="width: 160px; height: 35px;" alt="Safe Payment"> -->
                <h5 class="font-weight-bold ml-2 mb-3 pb-2">Moneypool </h5>
                <div class="card shadow-sm border-0" style="background: rgb(74, 30, 90);">
                  <div class="card-body px-3 py-3">
                    <p class="p-0 mb-1 text-white font-weight-bold">{{ userProfile.profile.lastname }} {{ userProfile.profile.firstname }} </p>
                    <h6 class="small">@{{ userProfile.username }}</h6>
                  </div>
                </div>
            </div>

            <ul class="list-unstyled components">
                <li class="">
                  <router-link to="/dashboard" exact> <i class="fas fa-tachometer-alt fa-sm mr-2"></i> Dashboard</router-link>
                </li>
                <li class="">
                  <router-link to="/mypools" exact> <i class="fas fa-database fa-sm mr-2"></i> My Pools</router-link>
                </li>
                <li class="">
                  <router-link to="/create" exact> <i class="fas fa-pen-alt fa-sm mr-2"></i> Create Pool</router-link>
                </li>
                <li class="">
                  <router-link :to="{name: 'contacts'}" exact> <i class="fas fa-address-book fa-sm mr-2"></i> Contacts</router-link>
                </li>
                <li class="">
                  <router-link :to="{ name: 'payouts'}" exact> <i class="fas fa-credit-card mr-2"></i> Payouts</router-link>
                </li>
                <!-- <li class="">
                  <router-link to="/" exact> <i class="fas fa-file-alt mr-2"></i> Reports</router-link>
                </li> -->
                <li class="">
                  <router-link :to="{name: 'myaccount'}" exact> <i class="fa fa-user-circle mr-2"></i> My Account</router-link>
                </li>
                <!-- <li class="">
                  <router-link to="/" exact> <i class="fas fa-phone-square-alt  mr-2"></i> Support</router-link>
                </li> -->
            </ul>

        </nav>

        <!-- Page Content  -->
        <main id="content" class="position-relative">

            <nav class="navbar navbar-expand navbar-light bg-light">
                <div class="container pr-3">
                    <button type="button" 
                      id="sidebarCollapse" 
                      class="btn btn-default d-lg-none d-block"
                      @click.prevent="closeSidebar()">
                      <i class="fas fa-bars"></i>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="nav navbar-nav ml-auto">
                            <li class="nav-item">
                              <a class="nav-link text-dark" @click.prevent="logout()"> <span class="fa fa-sign-out-alt text-muted"></span> Sign Out</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <!-- dashboard content area -->
            <div class="d-flex flex-column">

              <div class="container mb-5">
                  <router-view></router-view>
                
              </div>
<!-- 
              <footer class="mt-auto">
                <div class="card border-0 rounded-0">
                  <div class="card-body pb-2">
                    <h6 class="text-muted small">
                      Copyright &copy; {{ new Date().getFullYear() }}, Vesicash Innovative Technologies.

                    </h6>
                  </div>
                </div>
              </footer> -->
            </div>

        </main>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Dashboard',
    data() {
        return {
            sidebarActive: true,
        }
    },
    computed: {
      ...mapGetters([
        'userProfile'
      ]), 
      
      toggleSidebar() {
        return  {
          'active': this.sidebarActive == true,
          '' : this.sidebarActive == false
        }
      }
    },
    created() {
      this.$store.dispatch('getUserProfile')


      const meta_element = document.createElement('meta');
      meta_element.setAttribute('name', 'google-signin-client_id');
      meta_element.setAttribute('content', process.env.VUE_APP_GOOGLE_CLIENTID);
      document.head.appendChild(meta_element);

      window.gapi.load('auth2', () => {
          const auth2 = window.gapi.auth2.init();
      })

    },
    methods: {
      logout() {
          var auth2 = window.gapi.auth2.getAuthInstance();
              auth2.signOut().then(function () {
              console.log('User signed out.');
          });
          
          if (localStorage.getItem('access_token') && localStorage.getItem('user')) {

              localStorage.removeItem('access_token');
              localStorage.removeItem('expires_in');
              localStorage.removeItem('token_type');
              localStorage.removeItem('user');
          }

          // redirect to the login
          window.location.href = "/login"

      },
      closeSidebar() {
        this.sidebarActive = this.sidebarActive ? false: true;
      }

    }
};
</script>

<style scoped src="../assets/css/style.css"></style>